// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"08a92be5","977":"40944406"}[chunkId] + ".chunk.js";
};